import React from "react";

import { CusButton } from "../../Components/From/Button";
import { FormattedMessage } from "react-intl";
import { Modal, ModalBody } from "reactstrap";

function Tool_ServeBeforeMeal({
  data,
  setDTtoggle,
  setisDTrecord,
  onEditTaste,
  setDTvalue,
  DTvalue,
  hadleDT,
  setDTModel,
  isDTrecord,
  saveOrderAndGoBack
}) {  

  let specificationData = data.specification.filter((x)=>x.combination[0].taste.length > 0);
  let selectedVal = null;

  if(specificationData.length > 0){
    selectedVal = specificationData[0].combination[0].taste[0];
  }

  return (    
    <div>
      <Modal isOpen fade={false} backdrop={false}>
        <div className="Tool Tool__CusSp d-flex justify-content-center align-items-center ">
          <div className="Tool__CusSp__content d-flex flex-column h-75 justify-content-between p-5 position-relative min-h-400">
            <div className="d-flex flex-column position-absolute fixed-top p-4  my-2 h-100">
              <div className="Tool__CusSp__title">
                {" "}
                <FormattedMessage
                  id="popup.DuringOrAfterTheMeal"
                />
              </div>              
              <hr className="" />
              <div className="h-100 ">
                <div className="w-100 d-flex flex-wrap justify-content-between">
                  <div
                    onClick={() => {
                      setDTvalue(41);
                    }}
                    className={
                      DTvalue == 41 ?  "need_button-on w-45" : (selectedVal == 41 
                        ? "need_button-selected w-45" :"need_button w-45")
                    }
                  >
                    <FormattedMessage
                  id="popup.buttonDuringTheMeal"
                />
                  </div>
                  <div
                    onClick={() => {
                      setDTvalue(411);
                    }}
                    className={
                      DTvalue == 411 ?  "need_button-on w-45" : (selectedVal == 411 
                        ? "need_button-selected w-45" :"need_button w-45")
                    }
                  >
                    <FormattedMessage
                  id="popup.buttonAfterTheMeal"
                />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between m-0 p-4 position-absolute fixed-bottom bg-white">
              <div className="col-6 w-50 p-1">
                <CusButton.White
                  children={<FormattedMessage id="popup.buttonBack" />}
                  className="btn-block py-2"
                  onClick={() => {
                    setDTModel(false);
                  }}
                />
              </div>
              <div className="col-6  w-50 p-1">
                <CusButton.Red
                  children={<FormattedMessage id="popup.buttonConfirm" />}
                  className="btn-block py-2"
                  disabled={!DTvalue}
                  onClick={async () => {
                    try {
                      await hadleDT(DTvalue); // Wait for hadleDT to finish
                      setDTModel(false); // Set DTModel to false
                      // await saveOrderAndGoBack();
                    } catch (error) {
                      // Handle errors if any of the async functions fail
                      console.error("An error occurred:", error);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Tool_ServeBeforeMeal;
